import React from 'react'
import {CompanyWidget} from '../../../_metronic/partials/MapComponents/Widgets/CompanyWidget'

const Company = () => {
  return (
    <>
      <CompanyWidget className='' />
    </>
  )
}

export default Company
